import React, { useEffect, useState } from "react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { db } from "@/lib/firebase";
import { collection, getDocs } from "firebase/firestore";

const Vehicles: React.FC = () => {
	const [vehicles, setVehicles] = useState<any[]>([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		const fetchVehicles = async () => {
			setLoading(true);
			setError(null);
			try {
				const querySnapshot = await getDocs(collection(db, "vehicles"));
				const data = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
				setVehicles(data);
			} catch (err: any) {
				setError("Failed to load vehicles.");
			} finally {
				setLoading(false);
			}
		};
		fetchVehicles();
	}, []);

	return (
		<div>
			<h2 className="text-2xl font-bold mb-4">Vehicle Management</h2>
			<Button className="mb-4">Add Vehicle</Button>
			<Card>
				<CardHeader>
					<CardTitle>All Vehicles</CardTitle>
				</CardHeader>
				<CardContent>
					{loading ? (
						<div className="py-8 text-center text-muted-foreground">Loading...</div>
					) : error ? (
						<div className="py-8 text-center text-destructive">{error}</div>
					) : vehicles.length === 0 ? (
						<div className="py-8 text-center text-muted-foreground">No vehicles yet.</div>
					) : (
						<div className="border rounded-md">
							<div className="grid grid-cols-6 font-medium p-3 border-b bg-muted/50">
								<div>Make</div>
								<div>Model</div>
								<div>Year</div>
								<div>Plate</div>
								<div>Status</div>
								<div>Actions</div>
							</div>
							<div className="divide-y">
								{vehicles.map((v) => (
									<div key={v.id} className="grid grid-cols-6 p-3">
										<div>{v.make}</div>
										<div>{v.model}</div>
										<div>{v.year}</div>
										<div>{v.plate}</div>
										<div>{v.status}</div>
										<div>
											<Button variant="ghost" size="sm">
												Edit
											</Button>
										</div>
									</div>
								))}
							</div>
						</div>
					)}
				</CardContent>
			</Card>
		</div>
	);
};

export default Vehicles;
